import AuthService from "../../services/auth.service";
import { getCookie } from "../../services/cookies.service";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const user = JSON.parse(getCookie("user"));

export const register = createAsyncThunk(
  "auth/register",
  async (payload, thunkAPI) => {
    try {
      const response = await AuthService.register(payload);
      return response;
    } catch (err) {
      const data = err?.raw || err?.response?.data;

      return thunkAPI.rejectWithValue({
        message:
          data?.message ||
          data?.error?.message ||
          err?.message ||
          "Registration failed",
      });
    }
  },
);

export const login = createAsyncThunk(
  "auth/login",
  async (payload, thunkAPI) => {
    try {
      const response = await AuthService.login(payload);
      return response;
    } catch (err) {
      const data = err?.raw || err?.response?.data;
      const errorPayload = {
        message: data?.error?.message || data?.message || "Login failed",
        retry_after: data?.error?.attempts_remaining ?? null,
      };
      return thunkAPI.rejectWithValue(errorPayload);
    }
  },
);

export const logout = createAsyncThunk(
  "auth/logout",
  async (_, { dispatch }) => {
    await AuthService.logout();
    dispatch(clearAuth());
  },
);

export const updateUserAddress = createAsyncThunk(
  "auth/updateUserAddress",
  async (payload, thunkAPI) => {
    const data = await AuthService.updateUserAddress(payload);
    return data;
  },
);

export const updateUserAvatar = createAsyncThunk(
  "auth/updateUserAvatar",
  async (payload, thunkAPI) => {
    const response = await AuthService.updateUserAvatar(payload);
    return response;
  },
);

const initialState = user
  ? {
      user,
      retryAfter: 0,
      isLoggedIn: true,
      hasRedirectedToReset: false,
    }
  : {
      user: null,
      retryAfter: 0,
      isLoggedIn: false,
      hasRedirectedToReset: false,
    };

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    updateUserData: (state, action) => {
      const payload = action.payload;
      if (!payload) return;
      if (state.user) {
        state.user = { ...state.user, ...payload };
      } else {
        state.user = payload;
      }
      state.isLoggedIn = true;
    },

    clearAuth: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.retryAfter = 0;
      state.hasRedirectedToReset = false;
    },

    setRetryAfter: (state, action) => {
      state.retryAfter = action.payload;
    },

    setRedirectedToReset: (state, action) => {
      state.hasRedirectedToReset = action.payload;
    },

    clearRetryState: (state) => {
      state.retryAfter = 0;
      state.hasRedirectedToReset = false;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(register.fulfilled, (state, action) => {
        state.isLoggedIn = true;
        state.user = action?.payload?.user;
      })
      .addCase(register.rejected, (state, action) => {
        state.isLoggedIn = false;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoggedIn = true;
        state.user = action?.payload?.user;
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoggedIn = false;
        state.user = null;
      })
      .addCase(logout.fulfilled, (state, action) => {
        state.isLoggedIn = false;
        state.user = null;
      })
      .addCase(updateUserAddress.fulfilled, (state, action) => {
        state.user.address = action?.payload?.data?.data[0];
      })
      .addCase(updateUserAvatar.fulfilled, (state, action) => {
        state.user.userdetails.avatar = action?.payload?.data?.data;
      });
  },
});

export const {
  clearAuth,
  setRetryAfter,
  updateUserData,
  clearRetryState,
  setRedirectedToReset,
} = authSlice.actions;

const { reducer } = authSlice;
export default reducer;
